import { useRef } from "react";
import { motion } from "framer-motion";

const CLIENTS = [
  "ACME",
  "KP Group",
  "GAIL",
  "IGL",
  "MNGL",
  "ProClime",
  "SAF Association",
  "India Climate Week",
  "GH2 India",
  "IGHA · Hyvolution",
  "Chintan Research Foundation (CRF)",
  "CMAI",
];

function ClientCard({ name, index }) {
  const ref = useRef(null);

  const onMove = (e) => {
    const el = ref.current;
    if (!el) return;
    const r = el.getBoundingClientRect();
    el.style.setProperty("--mx", `${e.clientX - r.left}px`);
    el.style.setProperty("--my", `${e.clientY - r.top}px`);
  };

  return (
    <motion.div
      ref={ref}
      onMouseMove={onMove}
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.2 }}
      transition={{ duration: 0.55, delay: (index % 5) * 0.07, ease: [0.22, 1, 0.36, 1] }}
      data-testid="client-card"
      className="group relative grid h-24 sm:h-28 place-items-center rounded-2xl border border-black/10 bg-white px-4 overflow-hidden transition-all duration-300 hover:border-gold/60 hover:shadow-[0_10px_30px_rgba(224,19,39,0.12)]"
    >
      <div
        className="pointer-events-none absolute inset-0 opacity-0 transition-opacity duration-300 group-hover:opacity-100"
        style={{
          background:
            "radial-gradient(180px circle at var(--mx, 50%) var(--my, 50%), rgba(224,19,39,0.10), transparent 65%)",
        }}
      />
      <span className="relative font-display text-sm sm:text-base font-semibold tracking-wide text-black/60 transition-colors duration-300 group-hover:text-royal-deep text-center">
        {name}
      </span>
    </motion.div>
  );
}

export default function ClientWall() {
  return (
    <section className="relative py-20 sm:py-28">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <motion.p
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.6 }}
          className="font-mono text-[11px] sm:text-xs tracking-[0.3em] uppercase text-gold-dark"
        >
          Working across the business ecosystem
        </motion.p>
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.6, delay: 0.08 }}
          className="mt-4 font-display text-2xl sm:text-4xl font-bold tracking-tight text-royal-deep"
        >
          Trusted by teams shaping industry.
        </motion.h2>

        <div className="mt-10 grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-6 gap-3">
          {CLIENTS.map((c, i) => (
            <ClientCard key={c} name={c} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
}
